import React from 'react';
import { Row, Col, Form, Input, Select, Button, Card } from 'antd';
import { PlusOutlined, DeleteOutlined } from '@ant-design/icons';

const { Option } = Select;

interface ContactsFormSectionProps {
  t: any;
  contactTypeOptions: { value: string; label: string }[];
}

const ContactsFormSection: React.FC<ContactsFormSectionProps> = ({ t, contactTypeOptions }) => (
  <Form.List
    name="contacts"
  >
    {(fields, { add, remove }) => (
      <>
        {fields.map(({ key, name, ...restField }) => (
          <Card
            key={key}
            style={{ marginBottom: 16 }}
            extra={
              fields.length > 1 && (
                <Button
                  type="text"
                  danger
                  icon={<DeleteOutlined />}
                  onClick={() => remove(name)}
                />
              )
            }
          >
            <Row gutter={16}>
              <Col xs={24} sm={12}>
                <Form.Item
                  {...restField}
                  name={[name, 'name']}
                  label={t('common:name')}
                  rules={[{ required: true, message: t('common:validation.required', 'This field is required') }]}
                >
                  <Input />
                </Form.Item>
              </Col>
              <Col xs={24} sm={12}>
                <Form.Item
                  {...restField}
                  name={[name, 'position']}
                  label={t('common:position')}
                  rules={[]}
                >
                  <Input />
                </Form.Item>
              </Col>
              <Col xs={24} sm={12}>
                <Form.Item
                  {...restField}
                  name={[name, 'email']}
                  label={t('common:email')}
                  rules={[
                    { required: true, message: t('common:validation.required', 'This field is required') },
                    { type: 'email', message: t('common:validation.email', 'Please enter a valid email') }
                  ]}
                >
                  <Input />
                </Form.Item>
              </Col>
              <Col xs={24} sm={12}>
                <Form.Item
                  {...restField}
                  name={[name, 'phone']}
                  label={t('common:phone')}
                  rules={[{ required: true, message: t('common:validation.required', 'This field is required') }]}
                >
                  <Input />
                </Form.Item>
              </Col>
              <Col xs={24} sm={12}>
                <Form.Item
                  {...restField}
                  name={[name, 'type']}
                  label={t('common:type')}
                  rules={[{ required: true, message: t('common:validation.required', 'This field is required') }]}
                >
                  <Select>
                    {contactTypeOptions.map(opt => (
                      <Option key={opt.value} value={opt.value}>{t('sales:leads.contactType.'+opt.value, opt.label)}</Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
            </Row>
          </Card>
        ))}
        <Form.Item>
          <Button
            type="dashed"
            onClick={() => add({ type: 'Secondary' })}
            block
            icon={<PlusOutlined />}
          >
            {t('common:addContact')}
          </Button>
        </Form.Item>
      </>
    )}
  </Form.List>
);

export default ContactsFormSection; 